import React from 'react';
import { KbArticlePage } from 'src/content/types/content/kb-article';

interface KbArticlePageProps {
    entry: KbArticlePage;
}

const KbArticle = ({ entry: { title, body } }: KbArticlePageProps) => {
    const { diagnosis, cause, solution, summary } = body;

    const renderSection = (
        sectionTitle: string,
        __html: string | undefined
    ) => {
        if (!__html) {
            return <></>;
        }
        return (
            <>
                <h2>{sectionTitle}</h2>
                <div
                    dangerouslySetInnerHTML={{
                        __html
                    }}
                />
            </>
        );
    };

    return (
        <>
            {/*SkipLink*/}
            {/*AuthorTools*/}
            <div
                className="topic section-page flex-column-page"
                data-testid="page-template"
            >
                <div className="content">
                    {/*Header*/}
                    <div className="main-content-container flex-container margin-top-medium">
                        {/*PageTree*/}
                        <main className="topic__container">
                            {/*Breadcrumbs (with div wrapper)*/}
                            {/*NoticeHub*/}
                            <article
                                className="topic__inner-container margin-top-medium"
                                id="maincontent"
                            >
                                <div className="title margin-bottom-medium">
                                    <h1>{title}</h1>
                                </div>

                                <div className="topic__body">
                                    {/*TODO: rendering here will change based on loading of entries, etc.*/}
                                    {renderSection('Diagnosis', diagnosis)}
                                    {renderSection('Cause', cause)}
                                    {renderSection('Solution', solution)}
                                    {renderSection('Summary', summary)}
                                </div>
                                {/*Sidebar*/}
                            </article>
                        </main>
                    </div>
                </div>
                {/*Footer*/}
            </div>
        </>
    );
};

export default KbArticle;
